import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const TonsCarbono = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = [ 'Servicios logísticos (Más de 250 mdp)','Construcción (Más de 250 mdp)', 'Alimentos (Más de 10,000 mdp)','Retail (Más de 10,000 mdp)'];

  const data2023 = [2.2,100,200,3176];


  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map(label => data2023[allLabels.indexOf(label)]);


  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: dataValues2023,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 40, // Aumentar el padding inferior
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        offset: 5,
        formatter: (value) => `${value}`,
        font: { weight: 'bold', size: 14 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria y nivel de facturación',
        },
        stacked: false,
      },
      y: {
        title: {
          display: true,
          text: 'Ton CO2',
        },
        beginAtZero: true,
        max: 3200,
        stacked: false,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        onBarClick([industry]);
      }
    },
  };

  const infoContent = {
    Analisis: 'Se observa una gran variabilidad entre sectores durante el 2023, destacando Retail con la mayor huella registrada (3,176 toneladas de CO₂), en contraste con Servicios logísticos, con una emisión significativamente menor (2.2 toneladas). Estas diferencias pueden estar relacionadas con el volumen de operación, nivel de facturación y grado de madurez en prácticas de sostenibilidad, y refuerzan la importancia de medir y gestionar el impacto ambiental de la logística de forma diferenciada por sector.',
    formula: 'Huella de carbono 2023 (ton CO2) = Suma de huella de carbono por industria ',
    description: 'La gráfica muestra la cantidad de emisiones de CO₂ generadas por industria en operaciones logísticas. ',
  };
  
  return (
    <div style={{ width: '100%', height: '555px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TonsCarbono;
